export const turnOffWebCam = () => {
  const video = document.querySelector("video");
  const mediaStream = video.srcObject;
  const tracks = mediaStream.getTracks();
  tracks.forEach((track) => track.stop());
};

export const getFileType = (filepath) => {
  let type = "";
  if (filepath) {
    const file = filepath?.split(".");
    type = file[file.length - 1];
  }
  return type;
};


export function getFormattedDate() {
  const d = new Date();
  return [
    String(d.getDate()).padStart(2, "0"),
    String(d.getMonth() + 1).padStart(2, "0"),
    d.getFullYear()
  ].join("-");
}

